import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import { GetPagePermissionFn } from "../../common/authority";
import CssClass from "../../Styles/common.module.css";
import OrganizationListTable from "../../components/MasterSetup/Organization/OrganizationListTable";
import RegisterOrganization from "../../components/MasterSetup/Organization/RegisterOrganization";
import search from "../../assets/search-icon.png";
import register from "../../assets/register-icon.png";
import exportIcon from "../../assets/export-icon.png";

const PAGE_NAME = "Organization.js";
const MODULE_ID = "WEB_MAS_002";

const Organization = (props) => {
  document.title = common.c_TITLE + " - Organization";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [dataToBeSelect, setDataToBeSelect] = useState({
    OrganizationName: [],
    OrganizationCat: [],
    System: [],
  });

  const [searchData, setSearchData] = useState([]);
  const [allData, setAllData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);

  const [showAdd, setShowAdd] = useState(false);

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Organization";

        onLoadingHandler(true, "Getting Organization List, please wait...")

        setAllData([]);
        const listItems = [];
        const OrganizationNameSelected =
          searchData.OrganizationName !== undefined &&
          Object.keys(searchData.OrganizationName).length !== 0
            ? searchData.OrganizationName.map((n) => n.key)
            : "";

        const OrganizationCatSelected =
          searchData.OrganizationCat !== undefined &&
          Object.keys(searchData.OrganizationCat).length !== 0
            ? searchData.OrganizationCat.map((c) => c.key)
            : "";
        http
          .get(
            "api/Organization/GetAllOrganization?_orgName=" +
              OrganizationNameSelected +
              "&_orgCat=" +
              OrganizationCatSelected +
              "&_userId=" +
              userId,
            { timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
                  key: data.ORG_ID,
                  ORG_ID: data.ORG_ID,
                  ORG_NAME: data.ORG_NAME,
                  // ORG_CATEGORY: data.ORG_CATEGORY,
                  ORG_CATEGORY_ID: data.ORG_CATEGORY_ID,
                  ORG_CATEGORY_NAME: data.ORG_CATEGORY_NAME,
                  SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                  SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                  // TICKET_NUM_FORMAT: data.TICKET_NUM_FORMAT,
                  // TICKET_NUM_FORMAT_ID: data.TICKET_NUM_FORMAT_ID,
                  FORMAT: data.FORMAT,
                  ACTIVE_FLAG: data.ACTIVE_FLAG,
                  STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  // SYSTEM_USED: data.SYSTEM_USED,
                  REMARK: data.REMARK,
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                });
              });
            }
            setAllData(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting organization list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting organization list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";
      try {
        functionName = "useEffect Get Organization Name";
        onLoadingHandler(true, "Getting Organization Name List, please wait...");

        http
          .get("api/Organization/GetOrgName?_userId=" + userId, {
            timeout: 10000,
          })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ORG_ID,
                value: response.data[i].ORG_ID,
                label: response.data[i].ORG_NAME,
              });
            }
            setDataToBeSelect((prevState) => ({
              ...prevState,
              OrganizationName: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error(
              "Error on getting Organization name list. Please try again."
            );
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting Organization name list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";
      try {
        functionName = "useEffect Get Organization Category";
        onLoadingHandler(true, "Getting Organization Category, please wait...");

        http
          .get("api/Organization/GetOrgCategory?_userId=" + userId, {
            timeout: 10000,
          })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].ORG_CATEGORY_ID,
                value: response.data[i].ORG_CATEGORY_ID,
                label: response.data[i].ORG_CATEGORY_NAME,
              });
            }
            setDataToBeSelect((prevState) => ({
              ...prevState,
              OrganizationCat: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error(
              "Error on getting Organization category list. Please try again."
            );
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error(
          "Error on getting Organization category list. Please try again."
        );
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";
      try {
        functionName = "useEffect Get System";
        onLoadingHandler(true, "Getting System, please wait...");

        http
          .get("api/Organization/GetSystem?_userId=" + userId, {
            timeout: 10000,
          })
          .then((response) => {
            const listItems = [];
            for (var i = 0; i < response.data.length; i++) {
              listItems.push({
                key: response.data[i].SYSTEM_MST_ID,
                value: response.data[i].SYSTEM_MST_ID,
                label: response.data[i].SYSTEM_MST_NAME,
              });
            }
            setDataToBeSelect((prevState) => ({
              ...prevState,
              System: [...listItems],
            }));
          })
          .catch((err) => {
            toast.error("Error on getting system list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error(
          "Error on getting Organization category list. Please try again."
        );
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  //#region Event Handlers
  const showHideRegisterModal = () => {
    setShowAdd(!showAdd);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };
  //#endregion

  const selectOrganizationNameHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectOrganizationNameHandler.name;
      setSearchData((prevState) => ({
        ...prevState,
        OrganizationName: [...val],
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const selectOrganizationCatHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectOrganizationCatHandler.name;
      setSearchData((prevState) => ({
        ...prevState,
        OrganizationCat: [...val],
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const onExcelHandler = () => {
    const OrganizationNameSelected =
        searchData.OrganizationName !== undefined &&
        Object.keys(searchData.OrganizationName).length !== 0
          ? searchData.OrganizationName.map((n) => n.key)
          : "";

      const OrganizationCatSelected =
        searchData.OrganizationCat !== undefined &&
        Object.keys(searchData.OrganizationCat).length !== 0
          ? searchData.OrganizationCat.map((c) => c.key)
          : "";
   
      window.open(common.c_getApiUrl() + "api/Organization/ExportExcel?_orgName=" + OrganizationNameSelected + "&_orgCat=" + OrganizationCatSelected + "&_userId=" + userId);
  }

  return (
    <>
      <Comp.Header>Organization</Comp.Header>
      <Comp.SearchPanel onSubmit={onReloadHandler}>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Organization Name
          </td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
              options={dataToBeSelect.OrganizationName}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={true}
              value={searchData.OrganizationName}
              onChange={selectOrganizationNameHandler}
              isMulti
              enableSelectAll={true}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Organization Category
          </td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
              options={dataToBeSelect.OrganizationCat}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={true}
              value={searchData.OrganizationCat}
              onChange={selectOrganizationCatHandler}
              isMulti
              enableSelectAll={true}
            />
          </td>
        </tr>
      </Comp.SearchPanel>

      <div className={CssClass.btnWrapper}>
        <Comp.Button id="btnSearch" type="general" onClick={onReloadHandler}>
          SEARCH  <img src={search} alt="Search" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
        {actionAuthority.WRITE === "Y" && (
          <Comp.Button
            id="btnRegister"
            type="general"
            onClick={showHideRegisterModal}
          >
            REGISTER  <img src={register} alt="Register" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
          </Comp.Button>
        )} 
        <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
      </div>

      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>List of Organization</h3> */}
        {/* <hr /> */}
        <OrganizationListTable
          data={allData}
          onReload={onReloadHandler}
          page={PAGE_NAME}
          module={MODULE_ID}
          onLoading={onLoadingHandler}
          dataToBeSelect={dataToBeSelect}
          actionAuthority={actionAuthority}
        />
      </div>
      <RegisterOrganization
        showHide={showAdd}
        onHide={showHideRegisterModal}
        onReload={onReloadHandler}
        page={PAGE_NAME}
        module={MODULE_ID}
        onLoading={onLoadingHandler}
        dataToBeSelect={dataToBeSelect}
      />

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default Organization;
